// ----------------------------------------------------------------------

export const markdownClasses = {
  root: 'nml__markdown__root',
  content: {
    pre: 'nml__editor__content__pre',
    codeInline: 'nml__editor__content__codeInline',
    codeBlock: 'nml__editor__content__codeBlock',
    image: 'nml__editor__content__image',
    link: 'nml__editor__content__link',
  },
};
